import { Container } from "../../components/container";

import { cn } from "../../lib/cn";

import SERVICE_BOOKING from "../../images/new-design/services/service-booking.png";
import DINNING from "../../images/new-design/services/dinning.png";
import TRAVEL from "../../images/new-design/services/travel.png";

const services = [
  {
    id: "0",
    name: "IN-APP BOOKING",
    desc: "Reserve trusted services, experiences, and appointments - all in one place.",
    image: SERVICE_BOOKING,
  },
  {
    id: "1",
    name: "DINING",
    desc: "Discover and book your city's best tables.",
    image: DINNING,
  },
  {
    id: "2",
    name: "TRAVEL",
    desc: "Curated experiences for life on the move.",
    image: TRAVEL,
  },
];

const Dot = () => {
  return <div className="h-2 w-2 bg-yellow rounded-full" />;
};

const Divider = () => {
  return (
    <div className={cn(["h-auto w-[1px] bg-yellow hidden", "xl:block"])} />
  );
};

function Services() {
  return (
    <section className="bg-background py-9" aria-label="Services">
      <Container>
        <div
          className={cn([
            "flex flex-col items-center justify-between",
            "xl:flex-row",
          ])}
        >
          {services.map((item, index) => (
            <article
              key={item.id}
              className={cn([
                "flex items-center gap-4",
                "xl:mt-0",
                index === 0 ? "mt-0" : "mt-5",
              ])}
            >
              <div className="flex gap-6">
                <Divider />

                <img
                  alt={`${item.name} service illustration`}
                  src={item.image}
                  className="h-auto min-w-[164px] rounded-full"
                  width="164"
                  height="164"
                  loading="lazy"
                />
              </div>

              <div className="max-w-[200px]">
                <div className="flex items-center gap-2">
                  <Dot />
                  <h3 className="text-md font-roboto font-bold text-light-black">
                    {item.name}
                  </h3>
                </div>

                <p className="text-md font-roboto font-normal text-light-black">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}

export { Services };
